/* eslint-disable react/jsx-no-bind */
import { React } from 'react';
import Routes from './routes';
import './App.scss';

function App() {
  return (
    <div className="app">
      <Routes />
    </div>
  );
}

export default App;
